// extracted by mini-css-extract-plugin
export default {"zoomModal":"g1-z","image":"h1-z","button":"i1-z","isOverlayShown":"j1-z"};